import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { AdminContextService } from '../../context/admin-contex.service';
import { AdminService } from '../../services/admin.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-registro-actividad',
    templateUrl: './registro-actividad.component.html'
})
export class RegistroActividadComponent implements OnInit, OnDestroy {

    private _filters;
    public filtersForm: UntypedFormGroup;
    public filtersVisible = false;

    public data;
    public roles;

    public mensajes = new Array<Message>();
    public showError: boolean;

    public dropdownSection: number;
    public pestanaActiva = new Array<number>();

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;
    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public toCloseSpinner = 0;

    public orderBy: string;
    public columnId: number;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _sessionContext: SessionContextService,
        private readonly _adminContext: AdminContextService,
        private readonly _adminService: AdminService,
        private readonly _utilsService: UtilsService,
        private readonly _translate: TranslateService
    ) { }

    ngOnInit() {
        this.filtersForm = this._fb.group({
            fechaInicio: [''],
            fechaFin: [''],
            userName: [''],
            applicationRoleId: [''],
            action: [''],
            segundosMin: [''],
            segundosMax: ['']
        });

        this.filtersForm.get('fechaInicio').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('fechaFin').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());

        this._adminContext.registroActividadFilters = null;

        this.getRoles();
        this.applyFilters();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public get isSmallScreen() {
        return this._sessionContext.isSmallScreen();
    }

    public getRoles() {
        this._adminService.getRoles().toPromise().finally(() => {
        }).then((resp) => {
            this.roles = resp.map(el => ({ id: el.applicationRoleId, des: el.roleName }));
        });
    }

    public validDates() {
        if (this.filtersForm.get('fechaInicio').value && this.filtersForm.get('fechaFin').value) {
            if (this.checkDates(this.filtersForm.get('fechaInicio').value, this.filtersForm.get('fechaFin').value)) {
                this.clearDatesValidators();
            } else {
                this.filtersForm.get('fechaInicio').setErrors(['Invalid date']);
                this.filtersForm.get('fechaFin').setErrors(['Invalid date']);
            }
            if (this.filtersForm.get('fechaInicio').invalid || this.filtersForm.get('fechaFin').invalid) {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.fecha.error.finAnteriorInicio' });
            } else {
                this.showError = false;
                this.mensajes = [];
            }
        } else {
            this.clearDatesValidators();
            this.showError = false;
            this.mensajes = [];
        }
    }

    private clearDatesValidators() {
        if (this.filtersForm.get('fechaFin').errors && this.filtersForm.get('fechaFin').value) {
            this.filtersForm.get('fechaFin').clearValidators();
            this.filtersForm.get('fechaFin').updateValueAndValidity();
        }
        if (this.filtersForm.get('fechaInicio').errors && this.filtersForm.get('fechaInicio').value) {
            this.filtersForm.get('fechaInicio').clearValidators();
            this.filtersForm.get('fechaInicio').updateValueAndValidity();
        }
    }

    private checkDates(inicio, fin) {
        const inicioD = new Date(inicio);
        const finD = new Date(fin);
        return inicioD <= finD;
    }

    public checkValuesForm(): boolean {
        return (
            this.filtersForm.get('fechaInicio').value ||
            this.filtersForm.get('fechaFin').value ||
            this.filtersForm.get('userName').value ||
            this.filtersForm.get('applicationRoleId').value ||
            this.filtersForm.get('action').value ||
            this.filtersForm.get('segundosMin').value ||
            this.filtersForm.get('segundosMax').value
        ) ? true : false;
    }

    public filtrar() {
        this.validDates();

        if (this.filtersForm.valid) {
            this.applyFilters();
        }
    }

    public resetForm() {
        this.filtersForm.reset();
    }

    public applyFilters() {
        this.currentPage = 0;
        this.dropdownSection = -1;
        this._adminContext.registroActividadFilters = {
            fechaInicio: this.filtersForm.get('fechaInicio').value ?
                this._utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicio').value) : '',
            fechaFin: this.filtersForm.get('fechaFin').value ?
                this._utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFin').value) : '',
            userName: this.filtersForm.get('userName').value ? this.filtersForm.get('userName').value : '',
            applicationRoleId: this.filtersForm.get('applicationRoleId').value ? this.filtersForm.get('applicationRoleId').value.id : null,
            action: this.filtersForm.get('action').value ? this.filtersForm.get('action').value : '',
            elapsedMin_seconds: this.filtersForm.get('segundosMin').value ? Number(this.filtersForm.get('segundosMin').value) : null ,
            elapsedMax_seconds: this.filtersForm.get('segundosMax').value ? Number(this.filtersForm.get('segundosMax').value) : null ,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage
        };

        this.getRegistroActividad();
    }

    public getRegistroActividad() {
        if (this._adminContext.registroActividadFilters) {
            this._filters = this._adminContext.registroActividadFilters
        } else {
            this.applyFilters();
        }
        this._spinnerService.showSpinner();
        this._adminService.getRegistroActividad(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.data = resp.lista;
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });
    }

    public showSection(i) {
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
        this.pestanaActiva[i] = this.pestanaActiva[i] > 0 ? this.pestanaActiva[i] : 1;
        // Desplazamiento a la izquierda para tablet (mismo tamaño máx. que en table.scss)
        if (this.dropdownSection !== -1 && window.innerWidth <= 1199) {
            // Retardo en caso de que haya otro detalle abierto
            setTimeout(() => {
                document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }, 50);
        }
    }

    public pageChange(page) {
        this.dropdownSection = -1;
        this._adminContext.registroActividadFilters.numPagina = this.currentPage = page - 1;
        this.getRegistroActividad();
    }

    public itemsPerPageChange(items) {
        this.dropdownSection = -1;
        this._adminContext.registroActividadFilters.numPagina = this.currentPage = 0;
        this._adminContext.registroActividadFilters.tamPagina = this.itemsPerPage = items;
        this.getRegistroActividad();
    }

    public getIcon(prop: string) {
        let iconClass = 'fa fa-sort';
        if (this._filters && this._filters.orderItems && this._filters.orderItems[0].orderProperty === prop) {
            iconClass = this._filters.orderItems[0].orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
        }
        return iconClass;
    }

    public toOrderBy(columnFilter, idColumn) {
        this.columnId = idColumn;
        if (this.data && this.data.length > 0) {
            if (this._adminContext.registroActividadFilters) {
                this._filters = this._adminContext.registroActividadFilters;
                if (!this.orderBy || this.orderBy.includes('DESC')) {
                    this.orderBy = 'ASC' + idColumn;
                    this._filters.orderItems = [
                        {
                            orderProperty: columnFilter,
                            orderByDescending: false
                        }
                    ];
                } else if (this.orderBy.includes('ASC')) {
                    this.orderBy = 'DESC' + idColumn;
                    this._filters.orderItems = [
                        {
                            orderProperty: columnFilter,
                            orderByDescending: true
                        }
                    ];
                }
                this.getRegistroActividad();
            }
        }
    }

    public transformJson(jsonString: string) {
        let jsonObject = JSON.parse(jsonString);
        let jsonObjString = JSON.stringify(jsonObject, null, 2).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        return jsonObjString.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, (match) => {
            var cls = 'number';
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = 'key';
                } else {
                    cls = 'string';
                }
            } else if (/true|false/.test(match)) {
                cls = 'boolean';
            } else if (/null/.test(match)) {
                cls = 'null';
            }
            return '<span class="' + cls + '">' + match + '</span>';
        });
    }

    public trackByElementId(index: number, element: { id: number }): number {
        return element.id;
    }
}